import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { VrrButton, VrrCircleLoader, VrrTable } from '../../shared_components';
import AccountModal from './account_modal';
import { prepareBody, prepareHeader } from './services';
import { fetchAccounts, getAccounts } from '../../../redux/app/appActions';
import { manageAccounts } from '../../../redux/userProfile/userProfileActions';
import { TAccountsAPI } from './types';
import './ConnectedAccount.scss';

const ConnectedAccount: React.FC = () => {
  const { t } = useTranslation();
  const dispatch: any = useDispatch();
  const accounts = useSelector(getAccounts);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    dispatch(fetchAccounts());
  }, []);

  const closeModal = () => {
    setIsOpen(false);
  };

  const onSubmit = (newAccounts: TAccountsAPI[]) => {
    const toHide: string[] = [];
    const toDisplay: string[] = [];
    newAccounts.forEach((account) => {
      if (
        account.role === 'available' &&
        !toHide.includes(account.vrr_id.toString())
      ) {
        toHide.push(account.vrr_id.toString());
      } else if (!toDisplay.includes(account.vrr_id.toString())) {
        toDisplay.push(account.vrr_id.toString());
      }
    });
    dispatch(
      manageAccounts({
        toHideAccounts: toHide,
        toDisplayAccounts: toDisplay
      })
    );
    closeModal();
  };

  return (
    <div className="connected-account">
      <h4>{t('connected_account.title')}</h4>
      <VrrCircleLoader isEnable={!accounts?.length}>
        {!!accounts?.length && (
          <>
            <VrrButton
              className="manage-account"
              data-cy-id="user-profile-manage-account-button"
              onClick={() => {
                setIsOpen(true);
              }}
            >
              {t('connected_account.title')}
            </VrrButton>
            <VrrTable
              header={prepareHeader()}
              body={prepareBody(accounts)}
              tableProps={{
                borderless: true,
                striped: true,
                className: 'account-table'
              }}
            />
          </>
        )}
      </VrrCircleLoader>
      <AccountModal
        isOpen={isOpen}
        onCancelAction={closeModal}
        onSubmitAction={onSubmit}
      />
    </div>
  );
};

export default ConnectedAccount;
